import { router as auth } from './auth';
import errors from './errors';
import { router as viewerCards } from './viewer-cards';
import { router as viewerPages } from './viewer-pages';
import { router as viwerNewClassPages } from './viewer-newclass-pages';
import { router as viewerCatCards } from './viewer-cat-cards';
import { router as viewerCatIntro } from './viewer-cat-intro';
import { router as viewerCatPages } from './viewer-cat-pages';
import { router as viewerPreview } from './viewer-preview';
import { router as catQuizResults } from './cat-quiz-results';
import { router as questionPage } from './question-page';
import { router as sharedPage } from './shared-page';

export default [
  ...auth,
  ...errors,
  ...viewerCards,
  ...viewerPages,
  ...viwerNewClassPages,
  ...viewerCatCards,
  ...viewerCatIntro,
  ...viewerCatPages,
  ...viewerPreview,
  ...catQuizResults,
  ...questionPage,
  ...sharedPage,
];
